"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TreeMapStore = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _bmTreeModel = require("./bm-tree-model");

var _bmTreeStore = require("./bm-tree-store");

var TreeMapStore = /*#__PURE__*/function (_TreeStore) {
  (0, _inherits2.default)(TreeMapStore, _TreeStore);

  var _super = (0, _createSuper2.default)(TreeMapStore);

  function TreeMapStore() {
    var _this;

    var multipleSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    (0, _classCallCheck2.default)(this, TreeMapStore);
    _this = _super.call(this, multipleSelect);
    _this._storeMap = void 0;
    _this._storeMap = new _map2.default();
    return _this;
  }

  (0, _createClass2.default)(TreeMapStore, [{
    key: "get",
    value: function get(id) {
      var _this$_storeMap$get;

      return (_this$_storeMap$get = this._storeMap.get(id)) !== null && _this$_storeMap$get !== void 0 ? _this$_storeMap$get : null;
    }
  }, {
    key: "setDescendantsVisibleState",
    value: function setDescendantsVisibleState(item, expand) {
      var _this2 = this;

      var changed = [item.id];

      if (expand) {
        var _context;

        (0, _forEach.default)(_context = item.children).call(_context, function (c) {
          var childState = _this2._storeMap.get(c);

          if (childState && !childState.visible) {
            changed.push(c);
            childState.visible = true;
            childState.checked = item.checked;
          }
        });
      } else {
        var _context2;

        (0, _forEach.default)(_context2 = item.descendants).call(_context2, function (d) {
          var descendantState = _this2._storeMap.get(d);

          if (descendantState === null || descendantState === void 0 ? void 0 : descendantState.visible) {
            changed.push(d);
            descendantState.expanded = false;
            descendantState.checked = false;
            descendantState.selected = false;
            descendantState.indeterminate = false;
            descendantState.visible = false;
            item.indeterminate = false;
          }
        });
      }

      this.emitter.emit(_bmTreeModel.TreeStateChangeType.Visible, changed);
    }
  }, {
    key: "setPersistedStateMapItems",
    value: function setPersistedStateMapItems(t, oldStore, parent) {
      var _parentOldStateItem;

      var oldStoreItem = oldStore === null || oldStore === void 0 ? void 0 : oldStore.get(t.id);
      var subItems;
      var subItemsChecked;
      var parentOldStateItem;

      if (oldStore) {
        var _t$subItems$map, _t$subItems, _context3;

        var subItemsIds = (_t$subItems$map = (_t$subItems = t.subItems) === null || _t$subItems === void 0 ? void 0 : (0, _map.default)(_t$subItems).call(_t$subItems, function (s) {
          return s.id;
        })) !== null && _t$subItems$map !== void 0 ? _t$subItems$map : [];
        subItems = (0, _filter.default)(_context3 = (0, _map.default)(subItemsIds).call(subItemsIds, function (s) {
          return oldStore.get(s);
        })).call(_context3, function (o) {
          return Boolean(o);
        });
        subItemsChecked = (0, _filter.default)(subItems).call(subItems, function (s) {
          return s === null || s === void 0 ? void 0 : s.checked;
        });
        parentOldStateItem = parent ? oldStore.get(parent.id) : null;
      }

      var thereAreCheckedSubItems = subItems && subItemsChecked && subItems.length > 0 && subItemsChecked.length === subItems.length;
      var checked = oldStore ? Boolean((oldStoreItem === null || oldStoreItem === void 0 ? void 0 : oldStoreItem.checked) || thereAreCheckedSubItems || ((_parentOldStateItem = parentOldStateItem) === null || _parentOldStateItem === void 0 ? void 0 : _parentOldStateItem.checked)) : Boolean(t.checked);
      var selected = oldStoreItem ? oldStoreItem.selected : Boolean(t.selected);
      var indeterminate = oldStoreItem ? Boolean(oldStoreItem.indeterminate && subItems && subItemsChecked && subItemsChecked.length < subItems.length) : false;
      var visible = oldStoreItem && parent ? Boolean(oldStoreItem.visible && parent.expanded) : !parent || Boolean(t.selected) || parent.expanded;
      var expanded = oldStoreItem ? Boolean(oldStoreItem.expanded && t.subItems && t.subItems.length) : false;
      return {
        checked: checked,
        selected: selected,
        indeterminate: indeterminate,
        visible: visible,
        expanded: expanded
      };
    }
  }, {
    key: "setStoreMap",
    value: function setStoreMap(tree, parent, totalSelected, oldStore) {
      var _this3 = this,
          _context7;

      if (!oldStore) {
        oldStore = this._storeMap;
        this._store = [];
        this._storeMap = new _map2.default();
      }

      var treeIds = [];
      (0, _forEach.default)(tree).call(tree, function (t, i) {
        var _context4, _context5, _totalSelected;

        treeIds.push(t.id);

        if (parent) {
          parent.descendants.push(t.id);
          parent.children.push(t.id);
        }

        var ancestors = (0, _concat.default)(_context4 = []).call(_context4, (0, _toConsumableArray2.default)(parent ? parent.ancestors : []), (0, _toConsumableArray2.default)(parent ? [parent.id] : []));

        var _this3$setPersistedSt = _this3.setPersistedStateMapItems(t, oldStore, parent),
            checked = _this3$setPersistedSt.checked,
            selected = _this3$setPersistedSt.selected,
            indeterminate = _this3$setPersistedSt.indeterminate,
            visible = _this3$setPersistedSt.visible,
            expanded = _this3$setPersistedSt.expanded;

        var stateItem = {
          id: t.id,
          name: t.name,
          dataQeId: t.dataQeId,
          parentId: parent ? parent.id : 'root',
          ancestors: ancestors,
          descendants: [],
          children: [],
          checked: checked,
          selected: selected,
          indeterminate: indeterminate,
          visible: visible,
          expanded: expanded,
          layer: ancestors.length,
          index: i,
          allowSelect: t.allowSelect,
          leftIcon: t.leftIcon,
          rightIcon: t.rightIcon,
          href: t.href,
          showCheckBox: t.showCheckBox,
          details: t
        };
        totalSelected = t.selected ? (0, _concat.default)(_context5 = []).call(_context5, (0, _toConsumableArray2.default)((_totalSelected = totalSelected) !== null && _totalSelected !== void 0 ? _totalSelected : []), [stateItem]) : totalSelected;

        _this3._store.push(stateItem);

        _this3._storeMap.set(t.id, stateItem);

        if (t.selected) {
          _this3.setVisible(stateItem);
        }

        if (t.subItems && t.subItems.length > 0) {
          var res = _this3.setStoreMap(t.subItems, stateItem, totalSelected, oldStore);

          totalSelected = res;
        }
      });

      if (totalSelected && totalSelected.length > 0) {
        (0, _forEach.default)(totalSelected).call(totalSelected, function (s) {
          _this3.setVisible(s);
        });
      }

      if (parent) {
        var ancest = [];

        var _iterator = (0, _createForOfIteratorHelper2.default)(parent.ancestors),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var ancestorId = _step.value;

            var stateItem = this._storeMap.get(ancestorId);

            if (stateItem) {
              ancest.push(stateItem);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        (0, _forEach.default)(ancest).call(ancest, function (p) {
          var _context6;

          p.descendants = (0, _concat.default)(_context6 = []).call(_context6, (0, _toConsumableArray2.default)(p.descendants), treeIds);
        });
      }

      var ids = [];

      var _iterator2 = (0, _createForOfIteratorHelper2.default)((0, _keys.default)(_context7 = this._storeMap).call(_context7)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var k = _step2.value;
          ids.push(k);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.emitter.emit(_bmTreeModel.TreeStateChangeType.Visible, ids);
      return totalSelected;
    }
  }]);
  return TreeMapStore;
}(_bmTreeStore.TreeStore);

exports.TreeMapStore = TreeMapStore;
